export default __webpack_public_path__ + "static/media/BonusBet-Notification.44b5f850.svg";